// extracted by mini-css-extract-plugin
module.exports = {"login-page":"Login_login-page__25O17","login-aside":"Login_login-aside__mFHEo","logo-link":"Login_logo-link__oUWMq"};